<template>
  <div class="mt-2 p-4">
    <CRow class="mb-5">
      <CCol sm="12">
        <h5 style="color:black">Report Magang</h5>
        <hr class="mt-3 mb-4"/>
      </CCol>
    </CRow>
    <CRow class="mt-5 mb-2">
        <CCol sm="6">
            <FungsiMagangChart @flagFungsi="flag" />
        </CCol>
        <CCol sm="6">
            <TotalUangSakuMagangChart @flagUangSaku="flags" />
        </CCol>
    </CRow>
    <CRow class="mt-2">
        <CCol sm="12">
            <TableDivisiMagang @flagDivisi="flagss"/>
        </CCol>
    </CRow>
    <CRow class="mt-2 mb-4">
        <CCol sm="12">
            <TablePenanggungJawab @flagPenanggungJawab="flagsss" />
        </CCol>
    </CRow>
    <CRow class="mt-2 mb-4">
        <CCol sm="12">
            <TableUMR @flagUMP="flagssss" />
        </CCol>
    </CRow>
  </div>
</template>

<script>
import FungsiMagangChart from '../../widgets/FungsiMagangChart.vue'
import TotalUangSakuMagangChart from '../../widgets/TotalUangSakuMagangChart.vue'
import TableDivisiMagang from '../../../component/tableDivisiMagang.vue'
import TablePenanggungJawab from '../../../component/tablePenanggungJawab.vue'
import TableUMR from '../../../component/tableUMR.vue'

export default {
  name: 'Dashboard',
  components: {
      FungsiMagangChart,
      TotalUangSakuMagangChart,
      TableDivisiMagang,
      TablePenanggungJawab,
      TableUMR
  },
  data () {
    return {
        flag1: false,
        flag2: false,
        flag3: false,
        flag4: false,
        flag5: false,
    }
  },
  watch: {
      flag1() {
          this.check()
      },
      flag2() {
          this.check()
      },
      flag3() {
          this.check()
      },
      flag4() {
          this.check()
      },
      flag5() {
          this.check()
      }
  },
  methods: {
      flag(value) {
          if(value == true) {
              this.flag1 = true
          } else {
              this.flag1 = false
          }
      },
      flags(value) {
          if(value == true) {
              this.flag2 = true
          } else {
              this.flag2 = false
          }
      },
      flagss(value) {
          if(value == true) {
              this.flag3 = true
          } else {
              this.flag3 = false
          }
      },
      flagsss(value) {
          if(value == true) {
              this.flag4 = true
          } else {
              this.flag4 = false
          }
      },
      flagssss(value) {
          if(value == true) {
              this.flag5 = true
          } else {
              this.flag5 = false
          }
      },
      check() {
          if(this.flag1 == true && this.flag2 == true && this.flag3 == true && this.flag4 == true && this.flag5 == true) {
              this.$store.state.loadingScreen = false
          } else {
              this.$store.state.loadingScreen = true
          }
      }
  },
  mounted() {
  }
}
</script>

<style scoped>
.flexible {
  flex-grow: 1;
}
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(16, 16, 16, 1);
}
.card-subtitle {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
}
.card-emblem {
    float:right;
    background-color:rgba(48, 107, 221, 0.05);
    text-align: center;
    line-height: 32px;
    min-width:40px;
    min-height:40px;
    border-radius:50%;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.modals {
  overflow-y: initial !important;
}
.bodys-modal {
  overflow-y: auto;
  height: 65vh;
}
.modal-buttons {
    width:100%;
    height: 36px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.wrap{
    height: auto;
    width: 100%;
}
.bg-white {
  background-color: white;
}
.bgTab{
  background-color: rgba(249, 250, 252, 1);
}
.page-title{
  padding: 20px 40px 15px 40px;
}
::v-deep .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  /* border-color: ; */
  font-weight: bold;
  color: rgba(21, 100, 153, 1);
  border-bottom: 3px solid rgba(21, 100, 153, 1) !important;
  background-color: transparent;
}
::v-deep .nav-tabs .nav-item {
  border: none !important;
  border-bottom: 1px solid gainsboro;
}

::v-deep .nav-tabs .nav-link {
 padding: 14px;
 background-color: rgba(249, 250, 252, 1);
 border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item a {
  color: rgba(154, 154, 154, 1);
}
::v-deep .nav-item {
  border-bottom: 1px solid gainsboro;
}
::v-deep .nav-item {
  font-weight: bold!important;
  color: #606060;
  background-color: rgba(249, 250, 252, 1);
  width: 25%;
  text-align: center;
}
</style>